import { createSelector } from '@ngrx/store';

import { selectCollapsedLogo, selectExpandedLogo } from '@core/stores/auth/auth.selectors';

import { SideMenuViewModel } from './components/side-menu';
import { selectSideMenuExpanded } from './store/layout.selectors';

export const selectSideMenuViewModel = createSelector(
  selectSideMenuExpanded,
  selectExpandedLogo,
  selectCollapsedLogo,
  (sideMenuExpanded, expandedLogo, collapsedLogo): SideMenuViewModel | undefined => {
    if (!expandedLogo || !collapsedLogo) {
      return;
    }

    return {
      expanded: sideMenuExpanded,
      expandedLogoSrc: expandedLogo.src,
      expandedLogoWidth: expandedLogo.width,
      expandedLogoHeight: expandedLogo.height,
      collapsedLogoSrc: collapsedLogo.src,
      collapsedLogoWidth: collapsedLogo.width,
      collapsedLogoHeight: collapsedLogo.height,
    };
  }
);
